import { NgForOf, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input, TrackByFunction } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { Alert, AlertListItem } from '@app/alerts/state/alerts-state.models';
import { AccordionModule } from '@app/shared/modules/accordion/accordion.module';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';

@Component({
  selector: 'adspt-alerts-info',
  templateUrl: './alerts-info.component.html',
  styleUrls: ['./alerts-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NgIf,
    NgForOf,
    NgSwitch,
    NgSwitchCase,
    forwardRef(() => SharedDirectivesModule),
    AccordionModule,
  ],
})
export class AlertsInfoComponent {
  @Input()
  alert?: Alert;

  readonly trackByListItem: TrackByFunction<AlertListItem> = (_, item) => item.link;
}
